import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetConstantCategoryListPagingAndFilterRequest } from '../models/request/constantCategory/GetConstantCategoryListPagingAndFilterRequest';

export class ConstantCategoryService {
    static async exportConstantCategoryList(inputObj: GetConstantCategoryListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportConstantCategoryList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ConstantCategory/exportConstantCategoryList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getConstantCategoryListPagingAndFilter(inputObj: GetConstantCategoryListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetConstantCategoryListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ConstantCategory/GetConstantCategoryListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addConstantCategory(_constantCategoryId: string | undefined, _name: string, _code: string) {
        try {
            var inputObj = {
                constantCategoryId: _constantCategoryId,
                name: _name,
                code: _code
            }

            console.log('SERVICE CALL - AddConstantCategory', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ConstantCategory/AddConstantCategory', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteConstantCategory(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteConstantCategory', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ConstantCategory/deleteConstantCategory', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getConstantCategoryById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getConstantCategoryById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/ConstantCategory/getConstantCategoryById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}